// extracted by mini-css-extract-plugin
var _1 = "Contained-moduleactive__z8GVZ";
var _2 = "Contained-modulebasic__KFaKW";
var _3 = "Contained-modulecontained__YcR3g";
var _4 = "Contained-modulegrey__h2Tvb";
var _5 = "Contained-modulelight__l5ayw";
var _6 = "Contained-moduleskeleton__bZX5a";
export { _1 as "active", _2 as "basic", _3 as "contained", _4 as "grey", _5 as "light", _6 as "skeleton" }
